<template>
    <div class="template-generator-logo">
        <img v-image-error :src="appLogoImage" />
    </div>
</template>

<script>
import { $themeConfig } from '@themeConfig'
export default {
    computed:{
        appLogoImage(){
            if(this.img == "{{companyLogo}}") return $themeConfig.app.appLogoImage
            else return this.img
        }
    },
    props:{
        img:{
            type:String,
            default:"{{companyLogo}}"
        },
    }
}
</script>

<style>
.template-generator-logo{
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 1rem;
}

.template-generator-logo img{
    height: 70%;
    width: auto;
}
</style>